import { USER_STUDY_PLAN_TRANSLATION_KEY } from '@/shared/components/UserStudyPlan/constants';
import {
  localeEn,
  localeEs,
  localePt,
} from '@/shared/components/UserStudyPlan/i18n';

export const EXTERNAL_LOCALES_ES = {
  ...localeEs[USER_STUDY_PLAN_TRANSLATION_KEY],
};

export const EXTERNAL_LOCALES_PT = {
  ...localePt[USER_STUDY_PLAN_TRANSLATION_KEY],
};

export const EXTERNAL_LOCALES_EN = {
  ...localeEn[USER_STUDY_PLAN_TRANSLATION_KEY],
};
